import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import { apiMethodsConst } from '~/services/methods';
import { UpdateOfficeService } from '../services/UpdateOfficeService';
import type { IUpdateOfficeRequest } from '../types/UpdateOffice';

export const useUpdateOffice = () => {
  const dispatch = useDispatch();
  const currentUser = useAppSelector((state) => state.user?.user ?? null);

  return useMutation<void, unknown, IUpdateOfficeRequest>({
    mutationFn: (payload) => UpdateOfficeService.updateOffice(payload),
    onSuccess: (_data, { officeName, officeType, officeSpecialty, placeId, officeAddress }) => {
      if (!currentUser?.id) return;

      const existingAddress = currentUser.address?.[0] ?? {};
      const nextAddress =
        placeId && officeAddress
          ? [{ ...existingAddress, formatted_address: officeAddress, place_id: placeId }]
          : currentUser.address;

      dispatch({
        type: apiMethodsConst.EDIT_USER_REQUEST,
        payload: {
          ...currentUser,
          office_name: officeName,
          address: nextAddress,
          office_info: {
            ...(currentUser.office_info ?? {}),
            officeType,
            officeSpecialty,
          },
        },
      });
    },
  });
};
